import { EXPRESS_API } from 'configs/api/expressApi';

export const createQRVideo = async (data: any) => {
  const response = await EXPRESS_API.post(`/qr-videos`, data);
  return response.data;
};

export const updateQRVideo = async (data: any) => {
  const response = await EXPRESS_API.put(`/qr-videos/${data.qrId}`, data);
  return response.data;
};

export const deleteQRVideo = async (data: any) => {
  const response = await EXPRESS_API.delete(`/qr-videos/${data.qrId}`, {
    data,
  });
  return response.data;
};
